var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseRequestPolicy, } from '@azure/ms-rest-js';
import { TokenProvider } from '../helpers/TokenProvider';
class AuthorizationPolicy extends BaseRequestPolicy {
    // It's not useless, as it gives *public* access to the constructor
    constructor(nextPolicy, options) {
        super(nextPolicy, options);
        this.headerName = 'Authorization';
    }
    sendRequest(request) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addAuthorizationHeader(request);
            return this._nextPolicy.sendRequest(request);
        });
    }
    addAuthorizationHeader(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield TokenProvider.getAuthorizationToken();
            if (!request.headers.get(this.headerName) && token) {
                request.headers.set(this.headerName, token);
            }
        });
    }
}
export const authorizationPolicy = () => ({
    create: (nextPolicy, options) => new AuthorizationPolicy(nextPolicy, options),
});
